import _extends from "@babel/runtime/helpers/esm/extends";
import Box from '@mui/material/Box';
import { LoadingIndicator } from '../../LoadingIndicator';
import React from 'react';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingButton(props) {
  var children = props.children,
    loadingLabel = props.loadingLabel,
    loadingSpinnerProps = props.loadingSpinnerProps;
  return loadingLabel ? /*#__PURE__*/_jsx(_Fragment, {
    children: loadingLabel
  }) : /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'relative'
    },
    children: [/*#__PURE__*/_jsxs(Box, {
      visibility: "hidden",
      children: [" ", children]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        left: '50%',
        position: 'absolute',
        top: '50%',
        translate: '-50% -50%'
      },
      children: /*#__PURE__*/_jsx(LoadingIndicator, _extends({}, loadingSpinnerProps))
    })]
  });
}